import React, { useState } from "react";
import DataTable from "../../../../components/AdminTable/DataTable";
import { Link } from "react-router-dom";

function SupplierLedger() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Reference",
      accessorKey: "Referenc",
    }, {
        header: "G. Total",
        accessorKey: "G. Total",
      }, {
        header: "Paid",
        accessorKey: "Paid",
      }, {
        header: "Due",
        accessorKey: "Due",
      },
  ]);

  const [column] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Payment Amount",
      accessorKey: "Payment Amount",
    }, {
        header: "Note",
        accessorKey: "Note",
      },
  ]);
  const [data] = useState([]);

  return (
    <main className="my-16">
      <div className="text-[#7B20C7] text-3xl text-center my-4">
        Supplier Report
      </div>
      <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap  gap-5 ms-4 my-2 items-center ">
        <div className="flex flex-wrap  gap-5 ms-4 my-2 items-center justify-center">
          <div>
            <label htmlFor="" className="w-full lg:w-1/3">
              <span className="text-[#7B20C7] text-sm mb">Start Date</span>
              <div className="mb-2 pt-0">
                <input
                  type="date"
                  className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  required
                />
              </div>
            </label>
          </div>
          <div>
            <label htmlFor="" className="w-full lg:w-1/3">
              <span className="text-[#7B20C7] text-sm mb ">End Date</span>
              <div className="mb-2 pt-0">
                <input
                  type="date"
                  className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  required
                />
              </div>
            </label>
          </div>
        </div>

        <Link
          className="bg-[#7B20C7] text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 mt-3 w-fit"
          type="button"
        >
          Submit
        </Link>
      </div>
      <div className="text-[#7B20C7] text-3xl text-center my-4">
        Supplier Report
      </div>
      <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
      <div className="text-[#7B20C7] text-3md text-center my-4">Purchase</div>

      <DataTable columns={columns} data={data} />

      <div className="text-[#7B20C7] text-3md text-center my-4">
        Due Payment
      </div>

      <DataTable columns={column} data={data} />
    </main>
  );
}

export default SupplierLedger;
